import template from './location_distance.create.html'
import controller from './location_distance.create.controller'
import './location_distance.create.scss'

const locationDistanceCreateComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default locationDistanceCreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/location_distance/create/location_distance.create.component.js